import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { sessionApiClientAtom, authApiClientAtom } from "../state";
import { useSessionApiClient } from "./sessions";
import { useAuthApiClient } from "./auth";

const ApiClientSubscriber = () => {
  const sessionApiClient = useSessionApiClient();
  const setSessionApiClient = useSetRecoilState(sessionApiClientAtom);

  const authApiClient = useAuthApiClient();
  const setAuthApiClient = useSetRecoilState(authApiClientAtom);

  useEffect(
    () => setSessionApiClient(sessionApiClient),
    [setSessionApiClient, sessionApiClient]
  );
  useEffect(
    () => setAuthApiClient(authApiClient),
    [setAuthApiClient, authApiClient]
  );
};

export { ApiClientSubscriber };
